import { Snackbar, Alert } from "@mui/material"

const Toast = ({ open, message, severity, handleClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        "& .MuiAlert-root": {
          fontSize: "16px",
          fontWeight: "600",
          borderRadius: "4px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          minWidth: "250px",
          alignItems: "center",
        },
        "& .MuiAlert-icon": {
          fontSize: "20px",
          marginRight: "12px",
        },
        "& .MuiAlert-message": {
          padding: "8px 0",
        }
      }}
    >
   <Alert
  onClose={handleClose}
  severity={severity}
  variant="filled"
  sx={{
    backgroundColor: severity === 'success' ? '#00A651' : '#BB0A21',
    color: '#FFFFFF !important', // Force white text
    '& .MuiAlert-message': {
      color: '#FFFFFF !important' // Ensure message text is white
    }
  }}
>
  {message}
</Alert>
    </Snackbar>
  )
}

export default Toast